<mat-card
	class="active-table"
	*ngIf="activeGateways.length > 0"
>
	<mat-card-title>
		{{ 'privategateway.form.activetitle' | translate }}
	</mat-card-title>
	<mat-card-subtitle>
		{{ 'privategateway.form.activesubtitle' | translate }}
	</mat-card-subtitle>
	<mat-card-content>
		<sdp-generic-table
			[columnSchema]="columnSchema"
			[tableName]="'Gateways'"
			[tableData]="activeGateways"
			[rows]="5"
			[disabled]="disabled"
		></sdp-generic-table>
	</mat-card-content>
</mat-card>

<mat-card
	class="inactive-table"
	*ngIf="inactiveGateways.length > 0"
>
	<mat-card-title>
		{{ 'privategateway.form.inactivetitle' | translate }}
	</mat-card-title>
	<mat-card-subtitle>
		{{ 'privategateway.form.inactivesubtitle' | translate }}
	</mat-card-subtitle>
	<sdp-generic-table
		[columnSchema]="columnSchema"
		[tableName]="'Gateways'"
		[tableData]="inactiveGateways"
		[rows]="5"
		[disabled]="disabled"
	></sdp-generic-table>
</mat-card>